export const FETCH_COMPRAS_REQUEST = "FETCH_COMPRAS_REQUEST";
export const FETCH_COMPRAS_SUCCESS = "FETCH_COMPRAS_SUCCESS";
export const FETCH_COMPRAS_FAILURE = "FETCH_COMPRAS_FAILURE";
